/**
 * @voltxampere/ui — 1N4733 5.1V Zener variant (Sprint 38-3)
 *
 * Reference: Vishay 1N4728-1N4764 series 1N4733 (DO-41 axial Zener).
 *   breakdownVoltage = 5.1 V          (V_Z @ I_ZT)
 *   breakdownCurrent = 49e-3 A        (I_ZT — datasheet test current)
 *   ideality + saturationCurrent      Sprint 23 ZenerParamsSchema defaults
 *
 * Yaygın 5V regulated reference. Engine zero-diff: canonical
 * `zener` engine stamp (Sprint 23) reuse.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { zener } from "../zener.js";
export const zener1n4733 = {
    id: "1n4733",
    nameTr: "1N4733 (Zener 5.1V, DO41)",
    nameEn: "1N4733 (5.1V Zener, DO41)",
    shortcut: "Z",
    category: "active",
    viewBox: zener.viewBox,
    terminals: zener.terminals,
    defaultLabel: "D",
    defaultValue: "1N4733 5V1",
    schemaType: "zener",
    defaultParams: { breakdownVoltage: 5.1, breakdownCurrent: 49e-3 },
    renderSVG: () => zener.renderSVG(),
};
//# sourceMappingURL=zener-1n4733.js.map